var _mapInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/map");

var isKeyable = require('./_isKeyable');
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */


function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : _mapInstanceProperty(data);
}

module.exports = getMapData;